import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function FloatingUi() {
  return <div className="fixed bottom-5 right-5 z-40" data-id="element-108">
      <a aria-label="Abrir WhatsApp" href="https://wa.me/59899555019" className="whatsapp-flash flex h-14 w-14 items-center justify-center rounded-full bg-[#e9c8b6] text-[#1A1A1A] shadow-[0_10px_28px_rgba(26,26,26,0.18)] transition-transform duration-200 ease-out hover:-translate-y-1 focus-visible:-translate-y-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#e9c8b6]" data-id="element-109">
        <MessageCircleIcon size={23} strokeWidth={1.8} data-id="element-110" />
      </a>
    </div>;
}